// extracted by mini-css-extract-plugin
module.exports = {"Summary":"ShipmentsSummary_Summary___6gGp","Descriptions":"ShipmentsSummary_Descriptions__3qWv8","Icons":"ShipmentsSummary_Icons__a2nfH"};